var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  filter = require('lodash/filter'),
  AUTHORIZATION_TYPE = require('_js/constants/authorization');

function Notifier(params) {
  var self = this;
  self.API = params.api;

  var startAuth = window.authorizedAccountant
    ? AUTHORIZATION_TYPE.ACCOUNTANT
    : AUTHORIZATION_TYPE.AUDITOR;
  self.calculatorType = ko
    .observable(startAuth)
    .subscribeTo('authorizationType', true);

  self.showSumOfHours = ko.observable(false);
  self.showShortVersion = ko.observable(false);
  self.sumOfRemainingHours = ko.observable(0);

  // Used by the API call methods to detect if it was triggered by the user switching authorization type.
  self.changeInAuthorizationType = false;

  self.showCalculatorType = ko.observable(false);
  // Only show the accountant and auditor tabs if the user is both types.
  if (window.authorizedAccountant && window.authorizedAuditor) {
    self.showCalculatorType(true);
  }

  self.categories = ko.observableArray([]);
  if (params.categories === undefined) {
    self.getCategories();
    self.showShortVersion(true);
    params.categories = ko.observableArray([]);
  } else {
    self.showShortVersion(false);
    self.categories = params.categories;
  }

  self.bookKeeping = ko.observable(0);

  self.hoursDone = ko.observable(0).syncWith('totalHoursDone', true);
  self.unstructuredHoursDone = ko
    .observable(0)
    .syncWith('totalUnstructuredHoursDone', true);
  self.hoursRequirement = ko.observable(0).syncWith('hoursRequirement', true);
  self.hoursRequirementStructured = ko
    .observable(0)
    .syncWith('hoursRequirementStructured', true);

  self.categoriesWithRemainingHours = ko.observableArray([]);
  self.showNotification = ko.observable(false);

  if (self.showShortVersion()) {
    self.categories.subscribe(function() {
      if (
        params.categories === undefined ||
        params.categories === null ||
        params.categories.length === 0
      ) {
        params.categories(self.categories());
      }
      self.determineShowNotification(params.categories());
    });
  }
  // I don't actually use this variable for anything other than detecting
  // when there is a change in the four observables: hoursRequirement, hoursRequirementStructured, hoursDone, unstructuredHoursDone
  self.difference = ko.computed(function() {
    return (
      self.hoursRequirementStructured() -
      self.hoursDone() +
      (self.hoursRequirement() -
        self.hoursDone() -
        self.unstructuredHoursDone())
    );
  });

  // So when there is a change, we can calculate if we should show the notification.
  self.difference.subscribe(function() {
    self.determineShowNotification(params.categories());
  });

  // Initialize.
  if (!self.showShortVersion()) {
    self.determineShowNotification(params.categories());
  }
}

Notifier.prototype.init = function(element) {
  this.$element = $(element);
};

// Calculates if we should show the notification or not and sets the showNotification observable accordingly.
Notifier.prototype.determineShowNotification = function(categories) {
  var tmpCategories = this.findCategoriesWithRemainingHours(categories);
  this.categoriesWithRemainingHours(
    this.calculateRemainingHoursForCategories(tmpCategories)
  );
  if (this.categoriesWithRemainingHours().length > 0)
    if (this.hoursDone() > this.hoursRequirement()) {
      // Has the user done more hours than is required?
      // If we do have some categories that are still missing hours we want to show the notification.
      if (this.categoriesWithRemainingHours().length > 0) {
        this.showNotification(true);
        if (
          this.categoriesWithRemainingHours().length > 1 &&
          this.showShortVersion()
        ) {
          this.showSumOfHours(true);
          var sum = 0;
          this.sumOfRemainingHours(sum);
        }
      } else {
        this.showNotification(false);
      }
    } else {
      this.showNotification(true);
      if (
        this.categoriesWithRemainingHours().length > 1 &&
        this.showShortVersion()
      ) {
        this.showSumOfHours(true);
        var hours = 0;
        for (var j = 0; j < this.categoriesWithRemainingHours().length; j++) {
          // We do not want the Bookkeeping subcategory to be included in the sum.
          hours += this.categoriesWithRemainingHours()[
            j
          ].MissingHoursFromCurrentCategory();
        }
        this.sumOfRemainingHours(hours);
      }
    }
  this.categoriesWithRemainingHours.valueHasMutated();
};

// Finds all the categories that have less hours than what is required.
Notifier.prototype.findCategoriesWithRemainingHours = function(categories) {
  categories = categories.slice(0);
  return categories;
};

Notifier.prototype.calculateRemainingHoursForCategories = function(categories) {
  return filter(categories, function(category) {
    if (category.MissingHoursFromCurrentCategory) {
      category.MissingHoursFromCurrentCategory(
        category.Requirement - category.TotalHoursDone()
      );
    } else {
      category.MissingHoursFromCurrentCategory = ko.observable(
        category.Requirement - category.TotalHoursDone()
      );
    }

    return category.MissingHoursFromCurrentCategory() > 0;
  });
};

Notifier.prototype.getCategories = function() {
  var url =
    this.API.categoryHours +
    '?authorizationType=' +
    encodeURIComponent(this.calculatorType());

  APIHelper.get(
    url,
    function(response) {
      var categories = response.Categories;

      if (this.changeInAuthorizationType || this.categories().length === 0) {
        this.changeInAuthorizationType = false;
        // We want to replace all the "normal" values with observables. This way we can detect changes
        // and update the values in the child component without actually reloading the whole component.
        for (var i = 0; i < categories.length; i++) {
          categories[i].TotalHoursDone = ko.observable(
            categories[i].TotalStructuredHoursDone +
              categories[i].TotalUnstructuredHoursDone
          );
          categories[i].DoneStructuredHoursFromCurrentCategory = ko.observable(
            categories[i].DoneStructuredHoursFromCurrentCategory
          );
          categories[
            i
          ].DoneUnstructuredHoursFromCurrentCategory = ko.observable(
            categories[i].DoneUnstructuredHoursFromCurrentCategory
          );
          categories[i].PlannedHoursFromCurrentCategory = ko.observable(
            categories[i].PlannedHoursFromCurrentCategory
          );
          categories[i].Requirement = ko.observable(categories[i].Requirement);
          categories[i].UpdateCounter = ko.observable(0);
        }
        this.categories(categories);
      } else {
        // Only change the values since we already have the categories.
        for (i = 0; i < this.categories().length; i++) {
          this.categories()[i].TotalHoursDone(
            categories[i].TotalStructuredHoursDone +
              categories[i].TotalUnstructuredHoursDone
          );
          this.categories()[i].DoneStructuredHoursFromCurrentCategory(
            categories[i].DoneStructuredHoursFromCurrentCategory
          );
          this.categories()[i].DoneUnstructuredHoursFromCurrentCategory(
            categories[i].DoneUnstructuredHoursFromCurrentCategory
          );
          this.categories()[i].PlannedHoursFromCurrentCategory(
            categories[i].PlannedHoursFromCurrentCategory
          );
          this.categories()[i].Requirement(categories[i].Requirement);
          this.categories()[i].UpdateCounter(
            this.categories()[i].UpdateCounter() + 1
          );
        }
      }
      this.categories.valueHasMutated();
      // Could trigger get courses here if i get endYear in the categories.
    }.bind(this),
    function(response) {
      APIHelper.post('/api/log/error', {
        message: 'API-error: notifier.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

module.exports = Notifier;
